const Tag = ({ type }) => (
  <span className={`shrink-0 text-[9px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded ${type === "fact" ? "bg-emerald-500/15 text-emerald-300" : "bg-violet-500/15 text-violet-300"}`}>
    {type === "fact" ? "Fact" : "View"}
  </span>
);

const Points = ({ title, items = [], color }) => (
  <div>
    <p className={`text-[11px] uppercase tracking-widest mb-1 ${color}`}>{title}</p>
    <ul className="space-y-1">
      {items.map((x, i) => (
        <li key={i} className="flex gap-2 items-start text-xs text-slate-300"><Tag type={x.type} /><span>{x.text}</span></li>
      ))}
    </ul>
  </div>
);

const VALUE = { yes: "text-emerald-400", no: "text-rose-400", unclear: "text-slate-400" };

export const RunnerBreakdown = ({ r, compact }) => (
  <div className="rounded-xl bg-[#0B101D]/70 border border-white/5 p-3 space-y-3" data-testid={`breakdown-runner-${r.number}`}>
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="font-display font-bold">R{r.race_number} · {r.number}. {r.horse}</span>
      <span className="ml-auto text-[11px] font-mono text-slate-400">
        Confidence in analysis: <span className="text-blue-300">{r.analysis_confidence || "-"}</span>
      </span>
    </div>
    <div className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2"}`}>
      <Points title="Strengths" items={r.strengths} color="text-emerald-400" />
      <Points title="Risks" items={r.risks} color="text-rose-400" />
    </div>
    <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs">
      <span>Value: <span className={`font-bold uppercase ${VALUE[r.value] || VALUE.unclear}`}>{r.value || "unclear"}</span>
        {r.value_reason && <span className="text-slate-400"> — {r.value_reason}</span>}</span>
      <span>Win prob: <span className="font-mono text-amber-300">{r.win_probability != null ? `${r.win_probability}%` : "not estimated"}</span>
        {r.probability_basis && <span className="text-slate-400"> — {r.probability_basis}</span>}</span>
    </div>
    {r.missing_info?.filter(Boolean).length > 0 && (
      <p className="text-xs text-amber-200/80">Missing: {r.missing_info.filter(Boolean).join("; ")}</p>
    )}
  </div>
);
